import React from 'react'
import cn, { Argument as ClassName } from 'classnames'

export type LandingMessageErrorIconProps = {
    className?: ClassName
    style?: React.CSSProperties
}

export function LandingMessageErrorIcon({ className, style }: LandingMessageErrorIconProps): React.ReactElement {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={90} height={90} className={cn(className)} style={style}>
            <g fill="#DF0017">
                <path d="m63.596 27.08-5.902 5.9-1.844 1.845-28.77 28.77-1.044-1.043 28.77-28.77 1.845-1.844 5.901-5.902 1.044 1.043z" />
                <path d="M62.92 63.595 26.406 27.08l1.043-1.043 36.516 36.516-1.043 1.043z" />
                <path d="M45 1.475C20.962 1.475 1.475 20.962 1.475 45S20.962 88.525 45 88.525 88.525 69.038 88.525 45 69.038 1.475 45 1.475zM0 45C0 20.147 20.147 0 45 0s45 20.147 45 45-20.147 45-45 45S0 69.853 0 45z" />
            </g>
        </svg>
    )
}
